export const PACKAGE_BOOKING_EXPIRATION_MS = 30 * 60 * 1000;

export type PackageBookingDate =
  | Date
  | string
  | number
  | { toDate: () => Date }
  | null
  | undefined;

const getBookingDateMilliseconds = (bookingDate: PackageBookingDate) => {
  const value =
    bookingDate && typeof bookingDate === "object" && "toDate" in bookingDate
      ? bookingDate.toDate()
      : bookingDate;
  const milliseconds =
    value instanceof Date ? value.getTime() : Date.parse(`${value}`);

  return Number.isFinite(milliseconds) ? milliseconds : null;
};

export const getPackageBookingRemainingSeconds = (
  bookingDate: PackageBookingDate,
  now = Date.now(),
) => {
  const bookingDateMilliseconds = getBookingDateMilliseconds(bookingDate);
  if (bookingDateMilliseconds === null) return null;

  const remainingMilliseconds = Math.max(
    bookingDateMilliseconds + PACKAGE_BOOKING_EXPIRATION_MS - now,
    0,
  );

  return Math.ceil(remainingMilliseconds / 1000);
};

export const isPackageBookingExpired = (
  bookingDate: PackageBookingDate,
  now = Date.now(),
) => getPackageBookingRemainingSeconds(bookingDate, now) === 0;

export const formatPackageBookingRemainingTime = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  return `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;
};
